import "./Logout.less"
import { HoverPanelTemplate } from "../HoverPanelTemplate/HoverPanelTemplate";
import Images from "../../utils/Images";
import { useState } from "react";
import {getREM} from "../../utils/misc";
import { msgbox, MSG_TYPE } from "../../utils/Msgbox";
import { RootStore } from "../../store/RootStore";

type LogoutProps = {
    children: React.ReactElement;
};

export const Logout = (props: LogoutProps): React.ReactElement => {
    const [top, setTop] = useState(0);
    const [right, setRight] = useState(0);

    const onVisible = (node:HTMLElement): void => {
        const rect = node.getBoundingClientRect();
        const rem = getREM();
        setTop(rect.bottom + 0.14 * rem);
        setRight(document.body.clientWidth - rect.right);
    };

    const onClick = (): void => {
        msgbox("退出登录", MSG_TYPE.INFO, () => {
            RootStore.trainManage.interupt();
            RootStore.common.logout();
        });
    };

    const content = (): React.ReactElement => {
        return <div className="logout" style={{top: `${top}px`, right: `${right}px`}} onClick={onClick}>
            <img src={Images.logout}></img>
            <span>退出登录</span>
        </div>;
    };

    return <HoverPanelTemplate target={content()} node={props.children} onVisible={onVisible}></HoverPanelTemplate>
};